import _isArray from 'lodash/isArray';
import _initial from 'lodash/initial';
import _join from 'lodash/join';
import _last from 'lodash/last';
import _isEmpty from 'lodash/isEmpty';
import translate from './translate';
import $ from 'cheerio';

//This function converts a byline object to the string reperesntation of the given name
const bylineToString = (byline = {}) => {
  const { 'firstname': firstName = '', 'lastname': lastName = '' } = byline;
  const separator = (firstName && lastName) ? ' ' : '';

  return firstName + separator + lastName;
};

const authorsToString = (authors = [], language = 'en') => {
  if (_isArray(authors)) {
    if (authors.length > 1) {
      // if there are multiple authors, turn them into a readable list:
      //  [author1, author2, author3] => 'author1, author2 & author3'
      return `${_join(_initial(authors), ', ')} ${translate('&', language)} ${_last(authors)}`;
    } else {
      //If there is only one author, return them unchanged
      return _last(authors);
    }
  } else {
    //If there is only one author, return them unchanged
    return authors;
  }
};

const getLocalLink = (location, { type = '', id = '', slug = '', link = '' }) => {
  if (location === undefined || !type || !id || !slug) {
    return link;
  }

  if (!_isEmpty(location)) {
    const {
      protocol,
      hostname,
      port
    } = location;

    return `${protocol}//${hostname}${port ? ':' + port : ''}/${type}/${id}/${slug}`;
  }

  return link;
};

const convertHtmlStringToArrayElements = (htmlString) => {
  let bodyArray = Array.from($(htmlString));

  if (_isEmpty(bodyArray)) {
    bodyArray = Array.from($(`<div>${htmlString}</div>`));
  }

  return bodyArray || [];
};

export { bylineToString, authorsToString, getLocalLink, convertHtmlStringToArrayElements };



// WEBPACK FOOTER //
// ./app/utils/NewsUtils.js